export const getFullName = (user) => {
  if (!user) return null;

  return [
    user.firstName,
    user.middleName,
    user.lastName
  ].filter((v) => v).join(' ');
};

export const userHasRole = (user, ...roles) => roles.some((role) => user && user.roles.includes(role));

/**
 * Filters users for dropdown/select components.
 * Returns only active users and excludes system users.
 *
 * @param {Object} user - The user object to check
 * @returns {boolean} - True if user should be shown in dropdown
 */
export const isSelectableUser = (user) => {
  if (!user) return false;
  // Only show active users
  if (!user.active) return false;
  // Exclude ROLE_SYSTEM users
  if (user.roles && user.roles.includes('ROLE_SYSTEM')) return false;
  return true;
};

/**
 * Converts users object/array to sorted dropdown options.
 * Filters for active users and excludes system users.
 *
 * @param {Object|Array} users - Users object (keyed by ID) or array of users
 * @returns {Array} - Array of {value, label} options sorted by name
 */
export const getUserSelectOptions = (users) => {
  if (!users) return [];

  // Convert to array of [userId, userObject] entries
  const userEntries = Array.isArray(users)
    ? users.map(user => [user.id || user._id, user])
    : Object.entries(users);

  return userEntries
    .filter(([userId, user]) => userId && isSelectableUser(user))
    .sort(([, userA], [, userB]) => {
      const nameA = getFullName(userA);
      const nameB = getFullName(userB);
      return nameA.localeCompare(nameB);
    })
    .map(([userId, user]) => ({
      value: userId,
      label: getFullName(user)
    }));
};
